import React, {useCallback, useMemo, useState} from 'react';

import SelectBox, {
  Item,
  Props as SelectBoxProps,
  SelectBoxStartingPoint,
} from '#/form/selectable-input/SelectBox';
import {ChevronSmallDown} from '_/assets/images';
import {memo} from '_/utilities/memo';
import {fixItemTextMargins} from '_/utilities/sharedFilterItemHelpers';
import {Positioning} from '_/utilities/types';

import {FilterSelectBoxStyle} from './style';

/**
 * @deprecated Will be removed in LEXIAN-4297. Please use the components from webapp-lib instead.
 */
export type Props<T extends Item> = Omit<SelectBoxProps<T>, 'startingPoint'> & {
  defaultText: string;
  disableSearch?: boolean;
  disableSelect?: boolean;
};
/**
 * @deprecated Will be removed in LEXIAN-4297. Please use the components from webapp-lib instead.
 */
export const FilterSelectBoxComponent = <T extends Item>({
  selectedItem,
  defaultText,
  disableSearch = false,
  disableSelect,
  items,
  ...props
}: Props<T>): React.ReactElement => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  const handleExpandChange = useCallback(
    (expanded: boolean) => {
      setIsExpanded(expanded);
    },
    [setIsExpanded]
  );

  const editedItems = useMemo(() => {
    if (items) {
      return fixItemTextMargins(items);
    }
  }, [items]);

  return (
    <SelectBox<T>
      disableSelect={disableSelect}
      headerText={selectedItem ? selectedItem.text : defaultText}
      Icon={ChevronSmallDown}
      items={editedItems}
      placement={Positioning.BottomLeftAlignDown}
      searchable={disableSearch ? true : undefined}
      startingPoint={SelectBoxStartingPoint.Dropdown}
      {...props}
      expanded={isExpanded}
      onExpandedChange={handleExpandChange}
    />
  );
};

/**
 * @deprecated Will be removed in LEXIAN-4297. Please use the components from webapp-lib instead.
 */
export default memo(FilterSelectBoxComponent, FilterSelectBoxStyle);
